// extracted by mini-css-extract-plugin
export default {"nav":"index_nav__3cu63","nav-box":"index_nav-box__i5oPv","nav-box__image-box":"index_nav-box__image-box__nM+Gg","image-box__image":"index_image-box__image__R4rI0"};